import React from 'react';
import BiodiversityForm from '../BiodiversityForm';
import slug from 'constants/slug';
import { getOne, updateOne } from 'api/biodiversityApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['biodiversity.write'])
export default class BiodiversityEdit extends React.Component {
  static propTypes = {};

  state = {
    biodiversity: {},
  };

  async componentDidMount() {
    const { match } = this.props;
    const biodiversityID = match.params._id;
    const results = await getOne(biodiversityID);
    this.setState({ biodiversity: results.data });
  }

  handleSubmit = async (values) => {
    const { match } = this.props;
    const biodiversityID = match.params._id;
    const results = await updateOne(biodiversityID, values);
    if (results.success) {
      Message.success({ content: 'Sửa Thành Công' });
      this.props.history.push(slug.BIODIVERSITY.DETAIL_WITH_ID + biodiversityID);
    }
    if (results.error) Message.error({ content: results.message });
  };

  render() {
    const { biodiversity } = this.state;

    return (
      <BiodiversityForm
        isEdit
        biodiversity={biodiversity}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityEdit/index.js